<template>
  <transition name="slide-up">
    <div v-if="show" class="update-banner">
      <div class="update-banner__content">
        <div class="update-banner__left">
          <span class="update-banner__icon">🔄</span>
          <span class="update-banner__text">A new version is available</span>
        </div>
        <div class="update-banner__right">
          <button class="update-banner__btn" @click="refresh">Refresh</button>
          <button class="update-banner__close" @click="dismiss" aria-label="Close">×</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'UpdateBanner',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    async refresh () {
      if ('serviceWorker' in navigator) {
        try {
          const registration = await navigator.serviceWorker.getRegistration()
          if (registration) {
            await registration.update()
            if (registration.waiting) {
              registration.waiting.postMessage({ type: 'SKIP_WAITING' })
              return
            }
          }
        } catch (e) {
          // Fall through to a normal reload if the update check fails.
        }
      }
      window.location.reload()
    },
    dismiss () {
      this.$emit('dismiss')
    }
  }
}
</script>

<style scoped lang="scss">
.update-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  background: linear-gradient(135deg, #00a9e0 0%, #0090c0 100%);
  padding: 14px 20px;
  z-index: 10000;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);

  &__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: 1024px;
    margin: 0 auto;
    padding: 0 20px;

    @media screen and (max-width: 800px) {
      padding: 0 10px;
    }
  }

  &__left {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  &__right {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  &__icon {
    font-size: 20px;
  }

  &__text {
    color: #ffffff;
    font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif;
    font-weight: 600;
    font-size: 15px;
    letter-spacing: 0.05em;
  }

  &__btn {
    background-color: #FC9000;
    color: #ffffff;
    border: 2px solid #ffffff;
    border-radius: 8px;
    padding: 8px 20px;
    font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif;
    font-weight: 600;
    font-size: 14px;
    text-transform: uppercase;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background-color: #e08000;
      transform: scale(1.02);
    }

    &:active {
      transform: scale(0.98);
    }
  }

  &__close {
    background: transparent;
    border: none;
    color: rgba(255, 255, 255, 0.8);
    font-size: 24px;
    line-height: 1;
    cursor: pointer;
    padding: 0 8px;
    transition: color 0.2s ease;

    &:hover {
      color: #ffffff;
    }
  }
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.slide-up-enter,
.slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}

@media screen and (max-width: 480px) {
  .update-banner {
    padding: 10px 12px;

    &__content {
      padding: 0 8px;
    }

    &__left {
      gap: 8px;
    }

    &__right {
      gap: 8px;
    }

    &__text {
      font-size: 12px;
    }

    &__btn {
      padding: 6px 12px;
      font-size: 11px;
    }

    &__close {
      font-size: 20px;
      padding: 0 4px;
    }
  }
}
</style>
